var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"o-autobuyer-btn o-autobuyer-btn--tiny",on:{"click":_vm.toggleMode}},[_vm._v(" "+_vm._s(_vm.modeDisplay)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }